import {
  ANELTO_TIME_INTERVAL_SUCCESS,
  BREADCRUM_DEVICE_DETAIL_LOADER,
  BREADCRUM_DEVICE_DETAIL_REQUEST,
  BREADCRUM_DEVICE_DETAIL_SUCCESS,
  CLAIRVOYANT_TIME_INTERVAL_SUCCESS,
  DEVICES_COMMON_LOADER_VISIBILITY,
  DEVICES_LIST_SUCCESS,
  DEVICES_SIGNAL_LIST_REQUEST,
  DEVICES_SIGNAL_LIST_SUCCESS,
  DEVICE_DETAIL_LOADER,
  EVIEW_DEVICE_TIMELINE_SUCESS,
  FREEUS_TIME_INTERVAL_SUCCESS,
  RING_DEVICE_SUCCESS,
  SET_SELECTED_DEVICE_DETAIL,
  DEVICE_DETAIL_MANUAL_REFRESH_LOADER,
  DEVICE_REFRESH_VISIBILITY,
  DEVICE_SYNC_LOG,
  RESET_DEVICE_SYNC_LOG,
  DEVICE_SYNC_SUCESS,
  GET_DEVICE_DETAILS,
  GET_DEVICE_DETAILS_REQUEST,
  DEVICE_SYNC_HISTORY_SUCESS,
  FETCH_MORE_DEVICE_SYNC_HISTORY_SUCCESS,
  DEVICE_STATUS_REQUEST,
  DEVICE_STATUS_SUCCESS,
  RESET_DEVICE_STATUS,
  DEVICE_STATUS_FAILURE,
} from "./actionTypes";
import apis from "../../api/apiEndPoints";
import keys from "../../constants/keys";
import {
  getData,
  handleResponses,
  handleUnAuthorizedAccess,
  isMoreThanOneHourAgo,
} from "../../utility";
import { getApi, postApi } from "../../api/commonApi";
import {
  eventLogs,
  ringDevicePayload,
  syncEvents,
} from "../../utility/deviceDetailUtils";
import { BASE_URL } from "constants/routes/api";
import { SYNC_STATUS } from "constants/syncStatus";
import moment from "moment";

const returnToDispatch = (dispatch, type, payload) => {
  dispatch({
    type: type,
    payload: payload,
  });
};

export const getDeviceList = async (
  params,
  isDeviceDetail,
  deviceId,
  pullRefresh = false
) => {
  const { dispatch, history, userType, medical_alert_user_id } = params;
  const param = medical_alert_user_id
    ? `?medical_alert_user_id=${medical_alert_user_id}`
    : "";
  const API = BASE_URL + apis?.getDeviceList + param;
  let accessToken = await getData(keys?.accessTokenKey);

  if (!isDeviceDetail && !pullRefresh) {
    returnToDispatch(dispatch, DEVICES_COMMON_LOADER_VISIBILITY, true);
  }
  if (pullRefresh == true) {
    returnToDispatch(dispatch, DEVICE_REFRESH_VISIBILITY, true);
  }
  getApi(API, accessToken, userType)
    .then(async (res) => {
      returnToDispatch(dispatch, DEVICE_REFRESH_VISIBILITY, false);
      if (res?.data?.code === 200) {
        returnToDispatch(dispatch, DEVICES_LIST_SUCCESS, res?.data?.data);
        if (isDeviceDetail) {
          const list = res?.data?.data;
          const selectedDevice = list?.filter(
            (item) => item?.user_device_id === deviceId
          );
          if (selectedDevice && selectedDevice?.length > 0) {
            returnToDispatch(
              dispatch,
              SET_SELECTED_DEVICE_DETAIL,
              selectedDevice[0]
            );
          }
        }
      } else {
        returnToDispatch(dispatch, DEVICES_COMMON_LOADER_VISIBILITY, false);
        if (res?.data?.code === 401) {
          await handleUnAuthorizedAccess(history);
        }
      }
    })
    .catch(() => {
      returnToDispatch(dispatch, DEVICE_REFRESH_VISIBILITY, false);
      returnToDispatch(dispatch, DEVICES_COMMON_LOADER_VISIBILITY, false);
    });
};

export const getBreadcrumData = async (params) => {
  const { dispatch, payload, history, userType, deviceType } = params;
  const API =
    BASE_URL +
    (deviceType === "anelto"
      ? apis?.getAneltoBreadcrumData
      : deviceType === "freeus"
      ? apis?.getFreeusBreadcrumData
      : deviceType === "clairvoyant"
      ? apis?.getClairvoyantBreadcrumData
      : apis?.getEviewBreadcrumData);

  let accessToken = await getData(keys?.accessTokenKey);
  returnToDispatch(dispatch, BREADCRUM_DEVICE_DETAIL_REQUEST);
  postApi(API, accessToken, payload, userType)
    .then(async (response) => {
      if (response?.data?.code === 200) {
        returnToDispatch(
          dispatch,
          BREADCRUM_DEVICE_DETAIL_SUCCESS,
          response?.data?.data
        );
      } else {
        returnToDispatch(dispatch, BREADCRUM_DEVICE_DETAIL_LOADER, false);
        if (response?.data?.code === 401) {
          await handleUnAuthorizedAccess(history);
        }
      }
    })
    .catch((e) => {
      returnToDispatch(dispatch, BREADCRUM_DEVICE_DETAIL_LOADER, false);
      returnToDispatch(dispatch, DEVICES_COMMON_LOADER_VISIBILITY, false);
    });
};

export const updateDeviceName = async (params) => {
  const { dispatch, payload, setSnackBarMessage, history, onClose } = params;
  const API = BASE_URL + apis?.updateDeviceName;
  let accessToken = await getData(keys?.accessTokenKey);
  returnToDispatch(dispatch, DEVICES_COMMON_LOADER_VISIBILITY, true);
  postApi(API, accessToken, payload, params?.userType)
    .then(async (response) => {
      if (response?.data?.code === 200) {
        handleResponses(true, response?.data?.message, setSnackBarMessage);
        returnToDispatch(dispatch, DEVICES_COMMON_LOADER_VISIBILITY, false);
        setTimeout(() => {
          onClose();
          getDeviceList(params, true, payload?.user_device_id);
        }, 2500);
      } else {
        returnToDispatch(dispatch, DEVICES_COMMON_LOADER_VISIBILITY, false);
        handleResponses(false, response?.data?.message, setSnackBarMessage);
        if (response?.data?.code === 401) {
          await handleUnAuthorizedAccess(history);
        }
      }
    })
    .catch(() => {
      returnToDispatch(dispatch, DEVICES_COMMON_LOADER_VISIBILITY, false);
    });
};

export const updateStepGoal = async (params) => {
  const { dispatch, payload, setSnackBarMessage, history, onClose, userType } =
    params;
  const API = BASE_URL + apis?.updateStepGoal;
  let accessToken = await getData(keys?.accessTokenKey);
  returnToDispatch(dispatch, DEVICES_COMMON_LOADER_VISIBILITY, true);
  postApi(API, accessToken, payload, userType)
    .then(async (response) => {
      if (response?.data?.code === 200) {
        handleResponses(true, response?.data?.message, setSnackBarMessage);
        returnToDispatch(dispatch, DEVICES_COMMON_LOADER_VISIBILITY, false);
        setTimeout(() => {
          onClose();
          getDeviceList(params, true, payload?.user_device_id);
        }, 2500);
      } else {
        returnToDispatch(dispatch, DEVICES_COMMON_LOADER_VISIBILITY, false);
        handleResponses(false, response?.data?.message, setSnackBarMessage);
        if (response?.data?.code === 401) {
          await handleUnAuthorizedAccess(history);
        }
      }
    })
    .catch(() => {
      returnToDispatch(dispatch, DEVICES_COMMON_LOADER_VISIBILITY, false);
    });
};

export const getDeviceSignalHistory = async (params, pullRefresh) => {
  const { dispatch, history, userType, medical_alert_user_id, user_device_id } =
    params;
  const API = BASE_URL + apis?.getSignalHistoryList;
  let accessToken = await getData(keys?.accessTokenKey);
  if (pullRefresh == true) {
    returnToDispatch(dispatch, DEVICE_REFRESH_VISIBILITY, pullRefresh);
  } else {
    returnToDispatch(dispatch, DEVICES_SIGNAL_LIST_REQUEST);
  }
  const payload = {
    medical_alert_user_id: medical_alert_user_id,
    user_device_id: user_device_id,
  };
  postApi(API, accessToken, payload, userType)
    .then(async (res) => {
      returnToDispatch(dispatch, DEVICE_REFRESH_VISIBILITY, false);
      if (res?.data?.code === 200) {
        returnToDispatch(
          dispatch,
          DEVICES_SIGNAL_LIST_SUCCESS,
          res?.data?.data
        );
      } else {
        returnToDispatch(dispatch, DEVICES_COMMON_LOADER_VISIBILITY, false);
        if (res?.data?.code === 401) {
          await handleUnAuthorizedAccess(history);
        }
      }
    })
    .catch((e) => {
      returnToDispatch(dispatch, DEVICE_REFRESH_VISIBILITY, false);
      returnToDispatch(dispatch, DEVICES_COMMON_LOADER_VISIBILITY, false);
    });
};

export const ringMyDevice = async (
  dispatch,
  payload,
  setSnackBarMessage,
  setActiveModal,
  deviceType,
  userType,
  history
) => {
  let API = "";
  if (deviceType === "anelto") {
    API = BASE_URL + apis?.ringAneltoDevice;
  } else if (deviceType === "clairvoyant") {
    API = BASE_URL + apis?.ringClairvoyantDevice;
  } else if (deviceType === "eview") {
    API = BASE_URL + apis?.updateEviewFunction;
    payload = {
      ...payload,
      ...ringDevicePayload,
    };
  } else {
    API = BASE_URL + apis?.ringFreeusDevice;
  }
  let accessToken = await getData(keys?.accessTokenKey);
  returnToDispatch(dispatch, RING_DEVICE_SUCCESS, false);
  returnToDispatch(dispatch, DEVICES_COMMON_LOADER_VISIBILITY, true);

  postApi(API, accessToken, payload, userType)
    .then(async (response) => {
      if (response?.data?.code === 200) {
        returnToDispatch(dispatch, RING_DEVICE_SUCCESS, true);
        returnToDispatch(dispatch, DEVICES_COMMON_LOADER_VISIBILITY, false);
      } else {
        returnToDispatch(dispatch, DEVICES_COMMON_LOADER_VISIBILITY, false);
        handleResponses(false, response?.data?.message, setSnackBarMessage);
        if (response?.data?.code === 401) {
          await handleUnAuthorizedAccess(history);
        }
      }
    })
    .catch(() => {
      returnToDispatch(dispatch, RING_DEVICE_SUCCESS, false);
    });
};

export const getFreeusTimeline = async (params) => {
  const { dispatch, userType } = params;
  const API = BASE_URL + apis?.getFreeusTimeline;
  let accessToken = await getData(keys?.accessTokenKey);
  getApi(API, accessToken, userType)
    .then(async (res) => {
      if (res?.data?.code === 200) {
        returnToDispatch(
          dispatch,
          FREEUS_TIME_INTERVAL_SUCCESS,
          res?.data?.data
        );
      }
    })
    .catch(() => {});
};

export const getAneltoTimeline = async (params) => {
  const { dispatch, userType } = params;
  const API = BASE_URL + apis?.getAneltoTimeline;
  let accessToken = await getData(keys?.accessTokenKey);
  getApi(API, accessToken, userType)
    .then(async (res) => {
      if (res?.data?.code === 200) {
        returnToDispatch(
          dispatch,
          ANELTO_TIME_INTERVAL_SUCCESS,
          res?.data?.data
        );
      }
    })
    .catch(() => {});
};

export const getClairvoyantTimeline = async (params) => {
  const { dispatch, userType } = params;
  const API = BASE_URL + apis?.getClairvoyantTimeline;
  let accessToken = await getData(keys?.accessTokenKey);
  getApi(API, accessToken, userType)
    .then(async (res) => {
      if (res?.data?.code === 200) {
        returnToDispatch(
          dispatch,
          CLAIRVOYANT_TIME_INTERVAL_SUCCESS,
          res?.data?.data
        );
      }
    })
    .catch(() => {});
};

export const getEviewTimeLine = async (params) => {
  const { dispatch, userType } = params;
  const API = BASE_URL + apis?.getEviewTimeLine;
  let accessToken = await getData(keys?.accessTokenKey);
  getApi(API, accessToken, userType)
    .then(async (res) => {
      if (res?.data?.code === 200) {
        returnToDispatch(
          dispatch,
          EVIEW_DEVICE_TIMELINE_SUCESS,
          res?.data?.data
        );
      }
    })
    .catch(() => {});
};

export const getDeviceSyncHistory = async (params, pullRefresh) => {
  try {
    const { dispatch, payload, userType, fetchMore } = params;
    const API = BASE_URL + apis?.deviceSyncHistoryList;
    let accessToken = await getData(keys?.accessTokenKey);

    if (pullRefresh == true) {
      returnToDispatch(dispatch, DEVICE_REFRESH_VISIBILITY, pullRefresh);
    } else if (!fetchMore) {
      returnToDispatch(dispatch, DEVICES_SIGNAL_LIST_REQUEST);
    }

    postApi(API, accessToken, payload, userType)
      .then(async (res) => {
        returnToDispatch(dispatch, DEVICE_REFRESH_VISIBILITY, false);
        if (res?.data?.code === 200) {
          if (fetchMore) {
            returnToDispatch(
              dispatch,
              FETCH_MORE_DEVICE_SYNC_HISTORY_SUCCESS,
              res?.data?.data
            );
          } else {
            returnToDispatch(
              dispatch,
              DEVICE_SYNC_HISTORY_SUCESS,
              res?.data?.data
            );
          }
        } else {
          returnToDispatch(dispatch, DEVICES_COMMON_LOADER_VISIBILITY, false);
          if (res?.data?.code === 401) {
            await handleUnAuthorizedAccess();
          }
        }
      })
      .catch((e) => {
        returnToDispatch(dispatch, DEVICE_REFRESH_VISIBILITY, false);
        returnToDispatch(dispatch, DEVICES_COMMON_LOADER_VISIBILITY, false);
      });
  } catch (error) {}
};

export const getDeviceDetails = async (params) => {
  try {
    const {
      dispatch,
      history,
      userType,
      userDeviceId,
      isAutoTriggered = false,
    } = params;
    const API = `${BASE_URL + apis?.getDeviceDetail}`;
    let accessToken = await getData(keys?.accessTokenKey);
    returnToDispatch(dispatch, DEVICE_DETAIL_LOADER, true);
    returnToDispatch(dispatch, GET_DEVICE_DETAILS_REQUEST);

    postApi(API, accessToken, { userDeviceId }, userType)
      .then(async (response) => {
        const data = response?.data?.data;
        const statusCode = response?.data?.code;
        returnToDispatch(dispatch, DEVICE_DETAIL_LOADER, false);
        if (response?.data?.code === 200) {
          returnToDispatch(dispatch, GET_DEVICE_DETAILS, data);
          setDeviceSyncLog(dispatch, {
            log: eventLogs.data_fetch_success,
            loggedAt: moment()?.utc()?.toISOString(),
          });
          //for admin auto Sync Disbaled
          // const { triggerSync, eventType } = shouldSyncDeviceDetails(data);
          // if (triggerSync && !isAutoTriggered) {
          //   callSycsDevideDetails(params, true, eventType);
          //   return;
          // }
        } else {
          if (statusCode === 401) {
            await handleUnAuthorizedAccess(history);
          }
        }
      })
      .catch((error) => {
        returnToDispatch(dispatch, DEVICE_DETAIL_LOADER, false);
      });
  } catch (error) {}
};

export const resetDeviceStatus = (dispatch) => {
  returnToDispatch(dispatch, RESET_DEVICE_STATUS, null);
};

export const callSycsDevideDetails = async (
  params,
  isAuto = false,
  event = ""
) => {
  try {
    const {
      dispatch,
      userDeviceId,
      history,
      userType,
      isManual = false,
    } = params;
    let accessToken = await getData(keys?.accessTokenKey);
    const API = BASE_URL + apis?.syncDeviceData;
    const now = moment()?.utc()?.toISOString();
    const param = {
      userDeviceId,
      sync_type: isAuto ? "auto" : "manual",
      ...(isAuto && { auto_trigger_event: event }),
    };
    const logMessage = isAuto
      ? eventLogs?.auto_trigger
      : eventLogs?.manual_trigger;
    setDeviceSyncLog(dispatch, {
      log: logMessage,
      loggedAt: now,
    });
    if (isManual) {
      returnToDispatch(dispatch, DEVICE_DETAIL_MANUAL_REFRESH_LOADER, true);
    }
    postApi(API, accessToken, param, userType,false,true)
      .then(async (response) => {
        const statusCode = response?.data?.code;
        if (response?.data?.code === 200) {
          returnToDispatch(dispatch, DEVICE_DETAIL_LOADER, false);
          returnToDispatch(dispatch, DEVICE_SYNC_SUCESS, response?.data?.data);
          // Call device status API after successful sync (skip for InHome and Clairvoyant)
          getDeviceStatus(
            dispatch,
            { userDeviceId },
            userType,
            history
          );
        } else {
          if (statusCode === 401) {
            await handleUnAuthorizedAccess(history);
          }
        }
      })
      .catch((error) => {
        returnToDispatch(dispatch, DEVICE_DETAIL_LOADER, false);
      });
  } catch (error) {}
};

export const callDeviceSynLogs = async (params) => {
  try {
    const { dispatch, history, userType, payload } = params;
    let accessToken = await getData(keys?.accessTokenKey);
    const API = BASE_URL + apis?.deviceSyncLogs;
    postApi(API, accessToken, payload, userType,false,true)
      .then(async (response) => {
        const statusCode = response?.data?.code;
        if (statusCode === 200) {
          returnToDispatch(dispatch, RESET_DEVICE_SYNC_LOG, []);
        } else {
          if (statusCode === 401) {
            await handleUnAuthorizedAccess(history);
          }
        }
      })
      .catch((error) => {
        console.log("Error", error);
      });
  } catch (error) {
    console.log("error", error);
  }
};

const checkTimeStamp = (data) => {
  const locationTimeStamp = data?.deviceData?.locationData?.locationTimestamp;
  const featuresTimeStamp = data?.deviceData?.featuresData?.featuresTimestamp;
  const statusTimeStamp = data?.deviceData?.statusData?.statusTimestamp;
  const deviceType = data?.deviceInfo?.deviceType;

  if (deviceType === "anelto" || deviceType === "eview") {
    return (
      isMoreThanOneHourAgo(locationTimeStamp) &&
      isMoreThanOneHourAgo(statusTimeStamp)
    );
  } else {
    return (
      isMoreThanOneHourAgo(locationTimeStamp) &&
      isMoreThanOneHourAgo(statusTimeStamp) &&
      isMoreThanOneHourAgo(featuresTimeStamp)
    );
  }
};
//required commented code for auto syn trigger
const shouldSyncDeviceDetails = (data) => {
  if (!data?.syncHistory) {
    return { eventType: syncEvents?.noSuccessSync, triggerSync: true };
  }

  if (
    data?.syncHistory?.syncStatus === SYNC_STATUS.FAILED &&
    !data?.syncHistory?.isLastTwoFailed
  ) {
    return { eventType: syncEvents?.noSuccessSync, triggerSync: true };
  }
  if (
    data?.syncHistory &&
    data?.deviceData &&
    data?.deviceData?.featuresData &&
    data?.deviceData?.locationData &&
    data?.deviceData?.statusData
  ) {
    if (
      data?.deviceData?.dataTimestamp &&
      checkTimeStamp(data) &&
      data?.syncHistory?.syncStatus === SYNC_STATUS.COMPLETED
    ) {
      return { eventType: syncEvents?.oldData, triggerSync: true };
    }
    if (
      data?.deviceData?.dataTimestamp &&
      !checkTimeStamp(data) &&
      data?.syncHistory?.syncStatus === SYNC_STATUS.FAILED &&
      !data?.syncHistory?.isLastTwoFailed
    ) {
      return { eventType: syncEvents?.noSuccessSync, triggerSync: true };
    }
  }
  return { eventType: null, triggerSync: false };
};

export const setDeviceSyncLog = (dispatch, data) => {
  returnToDispatch(dispatch, DEVICE_SYNC_LOG, data);
};

export const setSelectedDeviceDetails = async (dispatch, data) => {
  localStorage.setItem(keys.selectedDeviceDetail, JSON.stringify(data));
  returnToDispatch(dispatch, SET_SELECTED_DEVICE_DETAIL, data);
};

export const setDeviceDetailLoaderVisibility = (dispatch, data) => {
  returnToDispatch(dispatch, DEVICE_DETAIL_LOADER, data);
  returnToDispatch(dispatch, DEVICE_DETAIL_MANUAL_REFRESH_LOADER, data);
};

export const getDeviceStatus = async (
  dispatch,
  { userDeviceId },
  userType,
  history
) => {
  try {
    // Get device_type from localStorage to check if it's InHome or Clairvoyant
    const selectedDeviceDetails = localStorage.getItem(keys.selectedDeviceDetail)
      ? JSON.parse(localStorage.getItem(keys.selectedDeviceDetail))
      : {};
    const deviceType = selectedDeviceDetails?.device_type;
    
    // Skip API call for InHome and Clairvoyant devices
    // InHome devices have empty device_type or device_type === "inhome"
    const isInHomeDevice = !deviceType || deviceType === "inhome";
    if (isInHomeDevice || deviceType === "clairvoyant") {
      return;
    }
    
    returnToDispatch(dispatch, DEVICE_STATUS_REQUEST, null);

    const API = BASE_URL + apis?.deviceStatus;
    let accessToken = await getData(keys?.accessTokenKey);

    const payload = userDeviceId ? { userDeviceId } : {};
    postApi(API, accessToken, payload, userType, false)
      .then(async (response) => {
        const statusCode = response?.data?.code;
        
        if (response?.data?.code === 200) {
          const deviceStatusData = {
            ...response?.data?.data,
            userDeviceId: userDeviceId,
          };
          returnToDispatch(
            dispatch,
            DEVICE_STATUS_SUCCESS,
            deviceStatusData
          );
        } else {
          returnToDispatch(dispatch, DEVICE_STATUS_FAILURE, null);
          if (statusCode === 401) {
            await handleUnAuthorizedAccess(history);
          }
        }
      })
      .catch(() => {
        returnToDispatch(dispatch, DEVICE_STATUS_FAILURE, null);
      });
  } catch (error) {
    returnToDispatch(dispatch, DEVICE_STATUS_FAILURE, null);
  }
};
